export default {"src":"/_next/static/image/public/images/flags/flag_65.37a7faba336afb5e06af705ec37f68c4.svg","height":16,"width":24};